// extracted by mini-css-extract-plugin
export default {"text":"TermsAndConditions-module_text_fb6054"};